import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MODES, configItemsFor, isMoto } from "@/lib/gps";

export const Head = ({ children }) => <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-primary">{children}</div>;
const sel = "h-10 w-full rounded-md border border-border bg-transparent px-2 text-sm";
const EXEC = [["", "Pendiente"], ["instalado", "Instalado"], ["no_instalado", "No instalado"]];
const Item = ({ label, children }) => <div className="space-y-1"><Label className="text-[11px] text-muted-foreground">{label}</Label>{children}</div>;
const Ro = ({ children, testid }) => <div className="flex h-10 items-center text-sm font-medium" data-testid={testid}>{children}</div>;

const Planned = ({ unit, n, editable, onChange }) => {
  const cfg = unit.config || {};
  const set = (k, v) => onChange({ ...unit, config: { ...cfg, [k]: v } });
  return (
    <div className="grid grid-cols-2 gap-2 md:grid-cols-4">
      <Item label="Plan"><Ro testid={`gps-unit-${n}-config-plan`}>{unit.plan.name}</Ro></Item>
      {isMoto(unit.plan) && <Item label="Modo">{editable
        ? <select className={sel} value={cfg.mode || ""} onChange={(e) => set("mode", e.target.value)} data-testid={`gps-unit-${n}-config-mode`}><option value="">Seleccionar</option>{MODES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select>
        : <Ro testid={`gps-unit-${n}-config-mode`}>{MODES.find(([v]) => v === cfg.mode)?.[1] || "—"}</Ro>}</Item>}
      {configItemsFor(unit.plan).map(([k, l]) => <Item key={k} label={l}>{editable
        ? <select className={sel} value={cfg[k] ? "1" : ""} onChange={(e) => set(k, !!e.target.value)} data-testid={`gps-unit-${n}-config-${k}`}><option value="">No requerido</option><option value="1">Requerido</option></select>
        : <Ro testid={`gps-unit-${n}-config-${k}`}>{cfg[k] ? "Requerido" : "No requerido"}</Ro>}</Item>)}
    </div>
  );
};

const Executed = ({ unit, n, editable, onChange }) => {
  const req = configItemsFor(unit.plan).filter(([k]) => unit.config?.[k]);
  const ex = unit.executed || { items: {}, notes: "" };
  const set = (patch) => onChange({ ...unit, executed: { ...ex, ...patch } });
  if (!req.length) return <p className="text-sm text-muted-foreground" data-testid={`gps-unit-${n}-executed-empty`}>Sin elementos requeridos en la configuración.</p>;
  return (
    <div className="space-y-2">
      <div className="grid grid-cols-2 gap-2 md:grid-cols-4">
        {req.map(([k, l]) => <Item key={k} label={l}><select className={sel} value={ex.items?.[k] || ""} disabled={!editable} onChange={(e) => set({ items: { ...ex.items, [k]: e.target.value } })} data-testid={`gps-unit-${n}-executed-${k}`}>{EXEC.map(([v, t]) => <option key={v} value={v}>{t}</option>)}</select></Item>)}
      </div>
      <Input placeholder="Motivo / observación" value={ex.notes || ""} disabled={!editable} onChange={(e) => set({ notes: e.target.value })} data-testid={`gps-unit-${n}-executed-notes`} />
    </div>
  );
};

export const GpsInstallConfig = ({ unit, n, configEditable, onChange }) => unit.plan ? (
  <div className="space-y-2 rounded-lg border border-primary/30 bg-primary/5 p-3" data-testid={`gps-unit-${n}-config`}>
    <Head>Configuración de instalación</Head>
    <Planned unit={unit} n={n} editable={configEditable} onChange={onChange} />
  </div>
) : null;

export const GpsExecuted = ({ unit, n, editable, onChange }) => unit.plan ? (
  <div className="space-y-2 border-t border-border pt-4" data-testid={`gps-unit-${n}-executed`}>
    <Head>Ejecutado</Head>
    <Executed unit={unit} n={n} editable={editable} onChange={onChange} />
  </div>
) : null;
